import { recordsApi } from "shared/api/recordsApi";

export const confirmPaymentRequest = (recordId) => {
  return recordsApi.confirmPayment(recordId);
};
